import React from "react";
import { Modal, Paper, Typography, Stack, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import TaskForm from "./TaskForm";

/**
 * Modal para crear/editar una tarea clínica.
 * Puede recibir defaultValues pre-filled desde cualquier panel.
 */
export default function TaskModal({ open, onClose, onSubmit, defaultValues, patients, employees, currentUser }) {
  const handleSubmit = (taskData) => {
    onSubmit(taskData);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: { xs: "95%", sm: 500 },
          maxHeight: "90vh",
          overflow: "auto",
          p: 3,
          borderRadius: 3,
          outline: "none",
        }}
      >
        <Stack spacing={2.5}>
          {/* Header */}
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" fontWeight={700}>
              {defaultValues?.id ? "Edit Task" : "New Task"}
            </Typography>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>

          {/* Pre-fill indicator */}
          {defaultValues?.patientName && (
            <Box
              sx={{
                p: 1,
                borderRadius: 1.5,
                bgcolor: "#EFF6FF",
                border: "1px solid #BFDBFE",
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem" }}>
                Creating task for: <strong>{defaultValues.patientName}</strong>
              </Typography>
            </Box>
          )}

          {/* Form */}
          <TaskForm
            defaultValues={defaultValues}
            patients={patients}
            employees={employees}
            currentUser={currentUser}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        </Stack>
      </Paper>
    </Modal>
  );
}
